import React, { useState } from 'react';
import useDocumentTitle from '../../../../hooks/useDocumentTitle/useDocumentTitle';
import { useTranslation } from 'react-i18next';
import useMediaQuery from '../../../../hooks/useMediaQuery/useMediaQuery';
import BackgroundImageContainer from '../../../../components/ui/BackgroundImageContainer/BackgroundImageContainer';
import Container from '../../../../components/ui/Container/Container';
import bg_image from "../../../../assets/images/login-bg.jpg";
import Card, { CardAppearAnimationType } from '../../../../components/ui/Card/Card';
import Button, { ButtonType } from '../../../../components/ui/Button/Button';
import CopyRightFooter from '../../../../components/ui/CopyRightFooter/CopyRightFooter';
import PhoneNumberInput from '../../../../components/ui/PhoneNumberInput/PhoneNumberInput';
import { isMaskValueValid } from '../../../../components/ui/PhoneNumberInput/utils';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


interface IPhoneFormat {
    phoneCode: string;
    country: string;
    mask?: string; // Mask is optional to handle the Serbia case
    // Add other properties that your IPhoneFormat interface has
}

const DeleteAccountPage: React.FC = () => {
    const { t } = useTranslation();

    //useDocumentTitle({ title: t("self-billing.labels.start-page-title") });

    const isMaxWidth470 = useMediaQuery('(max-width:450px)');

    const [phoneCode, setPhoneCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [countryPhoneCode, setCountryPhoneCode] = useState('');
    const [phoneFormat, setPhoneFormat] = useState<IPhoneFormat | null>(null); // Changed to IPhoneFormat | null
    const [noDriverPhoneProvided, setNoDriverPhoneProvided] = useState(false); // You might need to manage this state
    const [phoneNumberError, setPhoneNumberError] = useState<string | null>(null); // State to store the phone number error message
    const [submissionSuccess, setSubmissionSuccess] = useState(false); // New state for submission success

    const handlePhoneCodeChange = (val: any) => {
        setPhoneFormat(val); // Сохраняем полный объект с информацией о коде
        setPhoneCode(val.phoneCode);
        setCountryPhoneCode(val.country);
    };

    const handlePhoneNumberChange = (val: any) => {
        setPhoneNumber(val);
        setPhoneNumberError(null); // Clear error when phone number changes
    };

    const validatePhoneNumber = (val: string | null | undefined) => { // Take val as argument
        if (val === null || val === undefined || val === '' || phoneFormat === null || noDriverPhoneProvided === true) {
            return true;
        }

        // Type guard to ensure phoneFormat is not null before accessing its properties
        if (phoneFormat) {
            //phoneFormat.mask === undefined это единственный случай, для Сербии
            if (phoneFormat.mask === undefined)
                return true;

            return isMaskValueValid(val, phoneFormat.mask);
        }

        return false; // Handle the case where phoneFormat is unexpectedly null after the initial check
    };

    const handleSubmit = () => {
        setPhoneNumberError(null); // Clear any previous error message

        if (!phoneNumber) {
            setPhoneNumberError("Phone is required field."); // Use translation for "Please enter a valid phone number."
            return;
        }

        const isValid = validatePhoneNumber(phoneNumber); // Pass phoneNumber to the function

        if (!isValid) {
            setPhoneNumberError("The phone number was entered in an incorrect format."); // Use translation for "Please enter your phone number."
            return;
        }

        setTimeout(() => {
            setSubmissionSuccess(true);
        }, 500); // Simulate API call delay
    };


    return (
        <BackgroundImageContainer image={bg_image}>
            <Container centerContent={true} height={'calc(100% - 30px)'}>
                <Card cardAppearAnimationType={CardAppearAnimationType.FadeIn}
                    style={isMaxWidth470 ? { width: 'calc(100% - 20px)' } : { width: '450px' }}>
                    <div style={{ padding: '20px' }}>
                        <h2 style={{ textAlign: 'center', marginBottom: '25px', fontSize: '22px' }}>
                            Request for Personal Data Deletion
                        </h2>


                        {submissionSuccess ? (
                            <>
                                <p style={{ color: 'green', textAlign: 'left', marginBottom: '20px', fontWeight: 'bold' }}>
                                    <FontAwesomeIcon icon={faCheckCircle} style={{ marginRight: '5px' }} />
                                    Your request has been received.
                                </p>

                                <p style={{ color: '#4E4E4E', textAlign: 'left', marginBottom: '20px' }}>
                                    {"Our team will review it and remove your personal data as soon as possible."}
                                </p>
                            </>

                        ) : (
                            <>
                                <p style={{ textAlign: 'left', marginBottom: '20px', fontSize: '16px', color: '#4E4E4E' }}>
                                    To delete your personal data, please enter the <b>phone number</b> you used during registration.
                                </p>
                                <p style={{ textAlign: 'left', marginBottom: '20px', fontSize: '16px', color: '#4E4E4E' }}>
                                    After submitting, you will receive a confirmation that your request has been received and will be processed shortly.
                                </p>

                                <div className={'mgb-10'}>
                                    <label style={{ fontWeight: '500', marginBottom: '5px', display: 'block' }}>
                                        {"Phone number:"}
                                    </label>

                                    <PhoneNumberInput
                                        disabled={submissionSuccess} // Disable input after submission
                                        showIcon={false}
                                        phoneCode={phoneCode}
                                        phoneNumber={phoneNumber}
                                        onPhoneCodeChange={(val) => {
                                            handlePhoneCodeChange(val);
                                        }}
                                        onPhoneNumberChange={(val) => {
                                            handlePhoneNumberChange(val);
                                        }}
                                    />
                                    {phoneNumberError && (
                                        <p style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>{phoneNumberError}</p>
                                    )}
                                </div>
                            </>
                        )}

                        <Button
                            buttonType={ButtonType.Primary}
                            onClick={handleSubmit}
                            style={{ width: '100%' }}
                            disabled={submissionSuccess} // Disable button after submission
                        >
                            Submit
                        </Button>
                    </div>

                </Card>
            </Container>
            <CopyRightFooter />
        </BackgroundImageContainer>
    );
};

export default DeleteAccountPage;
